<template>
  <div class="segment-page">
    <div :class="loading ? 'hidden' : ''">
      <contacts
        v-if="segment !== null"
        mode="segment"
        :segment="segment"
        @fetchDataComplete="fetchDataComplete"
        @updateSearch="updateSearch"
        @updateFilters="updateFilters"
        @activateBusinessKitModal="activateBusinessKitModalCb"
        @activateAddToProjectModal="activateAddToProjectModalCb"
        @emitTotalTableCount="emitTotalTableCount"
        @selectedItemsChange="selectedItemsChange"
        tableSettingsName="segmentContacts"
      />
    </div>

    <div class="segment-page-loader" :class="loading ? '' : 'hidden'">
      <loading></loading>
    </div>

    <business-kit-modal
      :segment="segment"
      :sendBusinessKitModalOpen="sendBusinessKitModalOpen"
      :contactIds="contactIds"
      :totalTableCount="totalTableCount"
      @closeBusinessKitModal="closeBusinessKitModal"
    />

    <add-to-project-modal
      :segment="segment"
      :addToProjectModalOpen="addToProjectModalOpen"
      :contactIds="contactIds"
      :totalTableCount="totalTableCount"
      @closeAddToProjectModal="closeAddToProjectModal"
    />
  </div>
</template>

<script>
import Contacts from '@/components/helpers/DataDisplay/FilterResults/Contacts'
import BusinessKitModal from '@/components/helpers/DataDisplay/Segments/BusinessKitModal'
import AddToProjectModal from '@/components/helpers/DataDisplay/Segments/AddToProjectModal'
import SegmentsApi from "@/api/Segments";
import Ui from '@/classes/Ui'
import Loading from '@/components/helpers/Specific/Loading.vue'

export default {
  components: { Contacts, Loading, BusinessKitModal, AddToProjectModal },
  props: {
    id: {
      type: [Number, String],
      required: true,
    },
  },
  data() {
    return {
      segmentsApi: new SegmentsApi(),
      segment: null,
      segmentOriginal: null,
      segmentSave: null,
      changesPending: false,
      loading: false,
      sendBusinessKitModalOpen: false,
      addToProjectModalOpen: false,
      contactIds: [],
      totalTableCount: 0,
      selectedItems: [],
    };
  },
  async mounted() {
    this.loading = true
    this.segment = await this.segmentsApi.getSegment(this.id)   
    this.segmentOriginal = JSON.parse(JSON.stringify(this.segment))
    this.segmentSave = JSON.parse(JSON.stringify(this.segment))

    Ui.setSecondaryHeaderTabs({})
    this.setHeaderButtons()

    Ui.setTitle({ label: this.segment.name })

    Ui.setBreadcrumbs([
      {
        label: 'ui.segment.breadcrumb_back',
        link: {name: "segments"}
      }
    ])
  },
  methods: {
    activateBusinessKitModalCb(ids) {
      if (this.changesPending) {
        this.$store.commit("SET_NOTIFICATION", {
          title: "ui.segments.is_editing_state",
          type: "error"
        });
        return
      }

      this.contactIds = ids
      this.sendBusinessKitModalOpen = true
    },
    activateAddToProjectModalCb(ids) {
      if (this.changesPending) {
        this.$store.commit("SET_NOTIFICATION", {
          title: "ui.segments.is_editing_state",
          type: "error"
        });
        return
      }

      this.contactIds = ids
      this.addToProjectModalOpen = true
    },
    closeBusinessKitModal() {
      this.sendBusinessKitModalOpen = false
    },
    closeAddToProjectModal() {
      this.addToProjectModalOpen = false
    },
    setHeaderButtons() {
      Ui.setHeaderButtons([
        {
          name: "savesegment",
          action: "segments.save",
          classes: "btn-primary",
          disabled: this.changesPending == false || this.selectedItems.length != 0,
          function: this.saveSegment,
        },
      ])
    },
    selectedItemsChange(items) {
      this.selectedItems = items
      this.setHeaderButtons()
    },
    updateFilters(filters) {
      this.segmentSave.filters = filters
      this.segmentSave = JSON.parse(JSON.stringify(this.segmentSave))
    },
    updateSearch(searchkeywords) {
      this.segmentSave.search = searchkeywords
      this.segmentSave = JSON.parse(JSON.stringify(this.segmentSave))
    },
    async saveSegment() {
      this.segment = await this.segmentsApi.updateSegment(this.id, this.segmentSave)
      this.segmentOriginal = JSON.parse(JSON.stringify(this.segment))
      this.segmentSave = JSON.parse(JSON.stringify(this.segment))
    },
    fetchDataComplete() {
      this.loading = false
    },
    emitTotalTableCount(totalTableCount) {
      this.totalTableCount = totalTableCount
    },
  },
  watch: {
    segmentSave: {
      handler() {
        // Check if any changes have been made
        this.changesPending = _.isEqual(this.segmentSave, this.segmentOriginal) == false

        // Re-render the header buttons so that we disable the save button if no chanegs have been made
        this.setHeaderButtons()
      },
    }
  }
}
</script>

<style lang="sass" scoped>
.segment-page
  .segment-page-loader
    z-index: 200
    position: absolute
    top: 0
    left: 0
    margin: 0 auto
    width: 100%
    height: 100%
    &.hidden
      visibility: hidden
</style>



// WEBPACK FOOTER //
// Segment.vue?61229530